export const acivityStore = defineStore('acivity', {
  state: () => ({
    tab: 1, //新建课程或者编辑课程的步骤
  }),
  getters: {},
  actions: {},
  //   persist: true,
});
